<template>
  <div v-bind="$attrs">
    <q-btn
      v-if="activityTicket?.activityBooking?.activityUnitQuantity < 2 && supportActivityTicketEditing"
      class="col-auto"
      :class="{ 'q-px-xs': isDrawer }"
      icon="fal fa-trash-can"
      color="responsive-grey-2"
      text-color="responsive"
      round
      :dense="isDrawer"
      :size="isDrawer && $consumer ? 'sm': 'md'"
      @click.stop="resetSlide => $emit('delete', [orderItem], resetSlide)"
    >
      <q-tooltip>
        {{ $t('cart.clickOrSwipeToRemove', { item: activityTicket.activityLabel }) }}
      </q-tooltip>
    </q-btn>
    <q-item-section
      class="col-auto"
    >
      <div class="row justify-start items-center">
        <q-btn
          v-if="activityTicket?.activityBooking?.activityUnitQuantity > 1 && supportActivityTicketEditing"
          class="col-auto"
          :class="{ 'q-px-xs': isDrawer && $q.platform.is.ios }"
          icon="fal fa-minus"
          round
          color="responsive-grey-2"
          text-color="responsive"
          :size="isDrawer && $consumer ? 'sm': 'md'"
          data-test-id="guest-tickets-item-remove-button"
        />
        <div
          v-if="activityTicket?.activityBooking?.activityUnitQuantity"
          class="col-auto text-center q-px-sm self-center text-responsive"
          :style="{ 'line-height': $q.platform.is.ios ? '2' : undefined }"
          data-test-id="guest-tickets-item-count"
        >
          {{ `${activityTicket?.activityBooking?.activityUnitQuantity * activityTicket?.activityBooking?.activity.activityUnitDurationMinutes} mins` }}
        </div>
        <q-btn
          v-if="supportActivityTicketEditing"
          class="col-auto"
          :class="{ 'q-px-xs': isDrawer && $q.platform.is.ios }"
          icon="fal fa-plus"
          round
          color="responsive-grey-2"
          text-color="responsive"
          :size="isDrawer && $consumer ? 'sm': 'md'"
          data-test-id="activity-tickets-item-add-button"
        />
      </div>
    </q-item-section>
  </div>
</template>

<script>

export default {
  name: 'ItemAddAndRemoveButtons',
  props: {
    activityTicket: {
      type: Object,
      required: true,
      default: null
    },
    isDrawer: {
      type: Boolean,
      required: false,
      default: false
    },
    defaultOpened: {
      type: Boolean,
      required: false,
      default: true
    },
    viewOnly: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  emits: ['delete'],
  data () {
    return {
      supportActivityTicketEditing: false // TODO: remove this once we have a way to edit activity tickets
    }
  }
}
</script>
<style lang="scss" scoped>
  .q-btn--round.col-auto {
    padding: 0;
    min-height: 3em;
    min-width: 3em
  }
</style>
